module.exports = __webpack_public_path__ + "img/default-noimg.afef92b4.png";